import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EffectsModule } from '@ngrx/effects'
import { GroupRateEffects } from './group-rate.effects'

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([GroupRateEffects])],
  declarations: [],
})
export class RateStoreModule {}
